import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {
  exchangeToken: null,
  skipRToken: false,
};

const slice = createSlice({
  name: 'exchange',
  initialState: reHydrateStore('exchange') || initialState,
  reducers: {
    setExchangeToken: (state, { payload }) => ({
      ...state,
      exchangeToken: payload,
    }),
    setSkipRToken: (state, { payload }) => ({
      ...state,
      skipRToken: payload,
    }),
    restore: () => initialState,
  },
});

export const { setExchangeToken, setSkipRToken, restore } = slice.actions;

export default slice.reducer;
